"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBRolesPermissionService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class BBRolesPermissionService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        // roles and permissions
        this.rolesAndPermissionsUrl = '/rest-api/profile/v1/business/roles';
        // getRoles(roles: any, rolesInfo: any) {
        //     console.log('getRoles roles- ', roles);
        //     console.log('getRoles rolesInfo- ', rolesInfo);
        //     const finalRole = _.intersection(roles, rolesInfo.Role);
        //     console.log('getRoles finalRole- ', finalRole);
        //     if (finalRole[0] === roles[0]) {
        //         return true;
        //      } else {
        //         return false;
        //        }
        // }
    }
    getRolesAndPermissions(cacheResponse) {
        if (this.rolesData && cacheResponse !== false) {
            return rxjs_1.of(this.rolesData);
        }
        else if (this.rolesObservable) {
            return this.rolesObservable;
        }
        else {
            this.rolesObservable = this.get(this.rolesAndPermissionsUrl).pipe(operators_1.map((data) => {
                this.observable = null;
                this.rolesObservable = null;
                this.rolesData = data;
                return data;
            }), operators_1.share());
            return this.rolesObservable;
        }
    }
}
exports.BBRolesPermissionService = BBRolesPermissionService;
//# sourceMappingURL=bbroles.service.js.map